export default "__VITE_ASSET___ejOPr4r__"